import { useMemo } from 'react';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const useYandexApiKeys = () => {
  const { config } = useApplicationContext();

  return useMemo(
    () => ({
      yandexApiKey: config.get<string>('audience.YandexApiKey'),
      yandexSuggestApiKey: config.get<string>('audience.YandexSuggestApiKey'),
    }),
    [config],
  );
};
